import { useDebugValue, useState } from 'react';

import ajaxClient from '../../../../utils/ajaxClient';
import { isUserLoggedIn } from '../../../../helpers/userMetadataHelper';

import { HEADER_VALUE__CONTENT_TYPE } from '../../../../utils/ajaxClient/constants';
import { interceptErrorMessage } from '../../../../shared/helpers/apiErrorsInterceptor';

const useSendQuestionnaire = () => {
  useDebugValue('useSendQuestionnaire');

  const [isSending, setIsSending] = useState(false);

  const urlResolver = (menuItem, id) => {
    if (isUserLoggedIn()) {
      return `Forms/${id}`;
    }

    return `Questionnaires/${id}`;
  };

  const sendQuestionnaire = (menuItem, id, data, onSuccess, onError) => {
    setIsSending(true);
    const url = urlResolver(menuItem, id);

    return ajaxClient
      .postRequest(url, null, data, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (response) {
          setIsSending(false);
          if (onSuccess) {
            onSuccess();
          }
        }
      })
      .catch((exception) => {
        if (exception) {
          if (onError) {
            onError(interceptErrorMessage(exception));
          }

          setIsSending(false);
        }
      });
  };

  return {
    sendQuestionnaire, isSending,
  };
};

export default useSendQuestionnaire;
